<template>
  <div class="navigation-menu-item" v-on:click="navigate"
       :class="{ disabled: disabled }">
    {{ title }}
    <img v-if="icon" class="icon" :src="require(`@/assets/${icon}`)">
  </div>
</template>

<script>
import router from '../../router';

export default {
  name: 'NavigationMenuItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    targetPath: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
  },
  methods: {
    navigate() {
      if (this.disabled) {
        return;
      }
      router.push({ path: `/${this.targetPath}`, query: this.$route.query });
      this.$emit('navigate');
    },
  },
};
</script>

<style scoped lang="scss">
.navigation-menu-item {
  margin-bottom: 30px;
  font-size: 20px;
  cursor: pointer;

  .icon {
    margin-right: 10px;
    vertical-align: middle;
  }
}
</style>
